// any CSS you import will output into a single css file (app.css in this case)
import './scss/styles.scss';

import Alpine from 'alpinejs'

window.Alpine = Alpine


